import { render, staticRenderFns } from "./EsNearMatch.vue?vue&type=template&id=38651c5a&scoped=true&"
import script from "./EsNearMatch.vue?vue&type=script&lang=js&"
export * from "./EsNearMatch.vue?vue&type=script&lang=js&"
import style0 from "./EsNearMatch.vue?vue&type=style&index=0&id=38651c5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38651c5a",
  null
  
)

export default component.exports